import { fetchDataError, fetchDataStart, fetchDataSuccess } from '../actions';
import { SERVICE_TYPE } from '../../constants';

const setWithSwitchValues = (item) => ({
  ...item,
  // Если элемент активен или если это firewall, то с активным уровнем защиты состояние - checked
  isChecked: item.isEnabled || !!Number(item.firewallLevel),
  isDisabled: item.isBlocked,
});

const getFilteredServices = (list) => {
  const additionalServices = list?.filter((i) => Boolean(i.serviceId)).map(setWithSwitchValues);
  const extraServices = list
    ?.filter(({ serviceType }) => serviceType === SERVICE_TYPE.firewall || serviceType === SERVICE_TYPE.socialInternet)
    .map(setWithSwitchValues);

  return { additionalServices, extraServices };
};

export const commonReducer = {
  [fetchDataStart]: (state) => ({
    ...state,
    isFetching: true,
    error: null,
  }),
  [fetchDataSuccess]: (state, action) => {
    const { additionalServices, extraServices } = getFilteredServices(action.payload.additionalServices);

    return {
      ...state,
      isFetching: false,
      error: null,
      ...action.payload,
      additionalServices,
      extraServices,
    };
  },
  [fetchDataError]: (state, action) => {
    console.error(action.payload?.stack);

    return {
      ...state,
      isFetching: false,
      error: action.payload?.message,
    };
  },
};
